export const notify = (message: string, options?: INotifyOptions): void => {
  window.notify(message, options)
}
